// extracted by mini-css-extract-plugin
export default {"b_e_adiv":"Btneraser_b_e_adiv__-kfc3","b_e_img":"Btneraser_b_e_img__zYLkX","eraserdown":"Btneraser_eraserdown__XOyAB","b_e_img2":"Btneraser_b_e_img2__mEt-3"};